/* Arcwell theme scripts: cart drawer, product form, gallery, small UI helpers. */
(() => {
  const theme = window.theme || { routes: {} };
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  /* Money ---------------------------------------------------------------- */

  function formatMoney(cents, format) {
    const template = (format || theme.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const withDelimiters = (value, precision, thousands = ',', decimal = '.') => {
      const fixed = (Number(value) / 100).toFixed(precision).split('.');
      const whole = fixed[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      return fixed[1] ? `${whole}${decimal}${fixed[1]}` : whole;
    };
    const match = template.match(placeholder);
    const formats = {
      amount: () => withDelimiters(cents, 2),
      amount_no_decimals: () => withDelimiters(cents, 0),
      amount_with_comma_separator: () => withDelimiters(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => withDelimiters(cents, 0, '.', ','),
      amount_with_apostrophe_separator: () => withDelimiters(cents, 2, "'", '.'),
      amount_no_decimals_with_space_separator: () => withDelimiters(cents, 0, ' ', ','),
      amount_with_space_separator: () => withDelimiters(cents, 2, ' ', ','),
      amount_with_period_and_space_separator: () => withDelimiters(cents, 2, ' ', '.')
    };
    const key = match && formats[match[1]] ? match[1] : 'amount';
    return template.replace(placeholder, formats[key]());
  }

  /* Announcement bar ----------------------------------------------------- */

  function initAnnouncements(root = document) {
    $$('[data-announcement]', root).forEach((bar) => {
      const items = $$('.announcement__item', bar);
      if (items.length < 2 || bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      let index = 0;
      const delay = (parseInt(bar.dataset.speed, 10) || 4) * 1000;
      setInterval(() => {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, delay);
    });
  }

  /* Mobile menu ---------------------------------------------------------- */

  document.addEventListener('click', (event) => {
    const drawer = event.target.closest('[data-menu-drawer]');
    if (!drawer) return;
    if (event.target.closest('[data-menu-close]') || event.target.closest('.menu-drawer__list a')) {
      drawer.removeAttribute('open');
    }
  });

  /* Cart drawer ---------------------------------------------------------- */

  const Cart = {
    get drawer() {
      return $('[data-cart-drawer]');
    },

    open() {
      const drawer = this.drawer;
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('has-drawer');
      this.lastFocus = document.activeElement;
      window.setTimeout(() => $('.drawer__panel', drawer)?.focus(), 60);
    },

    close() {
      const drawer = this.drawer;
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('has-drawer');
      this.lastFocus?.focus?.();
    },

    render(sections) {
      const html = sections && sections['cart-drawer'];
      const drawer = this.drawer;
      if (!html || !drawer) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
      if (fresh) drawer.innerHTML = fresh.innerHTML;
    },

    setCount(count) {
      $$('[data-cart-count]').forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count === 0;
      });
    },

    async request(url, body) {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
      }
      return data;
    },

    async add(items) {
      const data = await this.request(`${theme.routes.cartAdd}.js`, { items });
      this.render(data.sections);
      const cart = await fetch(`${theme.routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      this.setCount(cart.item_count);
      this.open();
    },

    async change(line, quantity) {
      const drawer = this.drawer;
      drawer?.classList.add('is-busy');
      try {
        const data = await this.request(`${theme.routes.cartChange}.js`, { line, quantity });
        this.render(data.sections);
        this.setCount(data.item_count);
      } catch (error) {
        window.alert(error.message);
      } finally {
        this.drawer?.classList.remove('is-busy');
      }
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cart-toggle]');
    if (toggle && Cart.drawer) {
      event.preventDefault();
      Cart.open();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      Cart.close();
      return;
    }
    const lineButton = event.target.closest('[data-line-change]');
    if (lineButton) {
      Cart.change(Number(lineButton.dataset.lineChange), Math.max(0, Number(lineButton.dataset.qty)));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && Cart.drawer?.classList.contains('is-open')) Cart.close();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('[data-product-form], [data-quick-add]') || !Cart.drawer) return;
    event.preventDefault();

    const buttons = [$('[type="submit"]', form), event.submitter].filter(Boolean);
    const errorBox = $('[data-form-error]', form);
    const formData = new FormData(form);
    const id = Number(formData.get('id'));
    const quantity = Math.max(1, parseInt(formData.get('quantity') || '1', 10));

    buttons.forEach((button) => button.classList.add('is-loading'));
    if (errorBox) errorBox.hidden = true;
    try {
      await Cart.add([{ id, quantity }]);
    } catch (error) {
      if (errorBox) {
        errorBox.textContent = error.message;
        errorBox.hidden = false;
      } else {
        window.alert(error.message);
      }
    } finally {
      buttons.forEach((button) => button.classList.remove('is-loading'));
    }
  });

  /* Gallery -------------------------------------------------------------- */

  class Gallery {
    constructor(el) {
      this.el = el;
      this.track = $('[data-gallery-track]', el);
      this.slides = $$('.gallery__slide', el);
      this.thumbs = $$('[data-gallery-thumb]', el);
      this.dots = $$('.gallery__dot', el);
      this.index = 0;
      if (!this.track || this.slides.length === 0) return;

      $('[data-gallery-prev]', el)?.addEventListener('click', () => this.go(this.index - 1));
      $('[data-gallery-next]', el)?.addEventListener('click', () => this.go(this.index + 1));
      this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.go(Number(thumb.dataset.galleryThumb))));

      let frame;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const width = this.track.clientWidth || 1;
          this.setActive(Math.round(this.track.scrollLeft / width));
        });
      }, { passive: true });

      const start = Number(el.dataset.start) || 0;
      if (start > 0) this.go(start, false);
    }

    go(index, smooth = true) {
      const count = this.slides.length;
      const target = (index + count) % count;
      // Glide to neighbours; jump straight to far-away slides (e.g. a color swatch) instead of scrolling past them all.
      const glide = smooth && Math.abs(target - this.index) <= 1;
      // 'instant' (not 'auto'), because the track's CSS scroll-behavior is smooth and 'auto' would inherit it.
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: glide ? 'smooth' : 'instant' });
      this.setActive(target);
    }

    goToMedia(mediaId) {
      const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index >= 0) this.go(index);
    }

    setActive(index) {
      if (index === this.index && this.ready) return;
      this.ready = true;
      this.index = index;
      this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      const thumb = this.thumbs[index];
      const strip = thumb && thumb.parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        strip.scrollTo({ left: thumb.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2, behavior: 'smooth' });
      }
    }
  }

  /* Product -------------------------------------------------------------- */

  class Product {
    constructor(el) {
      this.el = el;
      this.section = el.closest('.shopify-section') || el.parentElement;
      this.data = JSON.parse($('[data-product-json]', el)?.textContent || '{}');
      this.form = document.getElementById(el.dataset.formId);
      this.idInput = this.form && $('[data-variant-id]', this.form);
      this.qtyInput = this.form && $('[data-qty-input]', this.form);
      this.atc = this.form && $('[data-atc]', this.form);
      this.sticky = $('[data-sticky-atc]', this.section);
      this.gallery = $('[data-gallery]', el) ? new Gallery($('[data-gallery]', el)) : null;
      this.variant = (this.data.variants || []).find((v) => String(v.id) === this.idInput?.value) || (this.data.variants || [])[0];

      $$('[data-variant-picker] input', el).forEach((input) => input.addEventListener('change', () => this.onOptionChange()));
      $$('[data-tier-qty]', el).forEach((input) => input.addEventListener('change', () => this.onTierChange(input)));
      $$('[data-qty-step]', el).forEach((button) => button.addEventListener('click', () => this.stepQuantity(Number(button.dataset.qtyStep))));
      $('[data-qty-visible]', el)?.addEventListener('change', (event) => this.setQuantity(parseInt(event.target.value, 10) || 1));

      this.initSticky();
      this.updateStock();
      this.updateTotals();
    }

    selectedOptions() {
      return $$('[data-variant-picker] fieldset', this.el).map((fieldset) => $('input:checked', fieldset)?.value ?? null);
    }

    onOptionChange() {
      const options = this.selectedOptions();
      options.forEach((value, index) => {
        const label = $(`[data-option-label="${index}"]`, this.el);
        if (label) label.textContent = value;
      });
      const variant = (this.data.variants || []).find((v) => v.options.every((option, i) => option === options[i]));
      this.setVariant(variant);
    }

    setVariant(variant) {
      if (!variant) {
        if (this.atc) {
          this.atc.disabled = true;
          $('[data-atc-label]', this.atc).textContent = 'Unavailable';
        }
        return;
      }
      this.variant = variant;
      if (this.idInput) this.idInput.value = variant.id;

      const current = $('[data-price-current]', this.el);
      const compare = $('[data-price-compare]', this.el);
      const badge = $('[data-price-badge]', this.el);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (current) current.textContent = formatMoney(variant.price);
      if (compare) {
        compare.hidden = !onSale;
        compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }
      if (badge) {
        badge.hidden = !onSale;
        badge.textContent = onSale ? `Save ${formatMoney(variant.compare_at_price - variant.price)}` : '';
      }

      if (this.atc) {
        this.atc.disabled = !variant.available;
        $('[data-atc-label]', this.atc).textContent = variant.available ? this.atc.dataset.label : 'Sold out';
      }
      const stickyButton = this.sticky && $('[data-sticky-button]', this.sticky);
      if (stickyButton) stickyButton.disabled = !variant.available;

      if (variant.featured_media && this.gallery) this.gallery.goToMedia(variant.featured_media.id);

      if (this.el.hasAttribute('data-update-url')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      this.updateStock();
      this.updateTotals();
    }

    onTierChange(input) {
      $$('.tier', this.el).forEach((tier) => tier.classList.toggle('is-selected', tier.contains(input)));
      this.setQuantity(Number(input.dataset.tierQty));
    }

    stepQuantity(step) {
      this.setQuantity(Math.max(1, (parseInt(this.qtyInput?.value, 10) || 1) + step));
    }

    setQuantity(quantity) {
      if (this.qtyInput) this.qtyInput.value = quantity;
      const visible = $('[data-qty-visible]', this.el);
      if (visible) visible.value = quantity;
      this.updateTotals();
    }

    // Shopify rounds the discount amount (not the total) to the nearest cent.
    tierTotal(quantity, discount) {
      const full = this.variant.price * quantity;
      return full - Math.round((full * discount) / 100);
    }

    updateTotals() {
      if (!this.variant) return;
      $$('[data-tier-qty]', this.el).forEach((input) => {
        const tier = input.closest('.tier');
        const quantity = Number(input.dataset.tierQty);
        const discount = Number(input.dataset.tierDiscount);
        const full = this.variant.price * quantity;
        const total = this.tierTotal(quantity, discount);
        const totalEl = $('[data-tier-total]', tier);
        const fullEl = $('[data-tier-full]', tier);
        const saveEl = $('[data-tier-save]', tier);
        if (totalEl) totalEl.textContent = formatMoney(total);
        if (fullEl) fullEl.textContent = formatMoney(full);
        if (saveEl) saveEl.textContent = `Save ${formatMoney(full - total)}`;
      });

      if (!this.sticky) return;
      const selectedTier = $('[data-tier-qty]:checked', this.el);
      const quantity = parseInt(this.qtyInput?.value, 10) || 1;
      const total = selectedTier
        ? this.tierTotal(Number(selectedTier.dataset.tierQty), Number(selectedTier.dataset.tierDiscount))
        : this.variant.price * quantity;
      const price = $('[data-sticky-price]', this.sticky);
      const name = $('[data-sticky-variant]', this.sticky);
      if (price) price.textContent = formatMoney(total);
      if (name && this.data.variants.length > 1) name.textContent = `${this.variant.title} · `;
    }

    updateStock() {
      const notice = $('[data-low-stock]', this.el);
      const source = $('[data-inventory-json]', this.el);
      if (!notice || !source || !this.variant) return;
      let stock = {};
      try {
        stock = JSON.parse(source.textContent);
      } catch (error) {
        return;
      }
      const quantity = stock[this.variant.id];
      const threshold = Number(notice.dataset.threshold);
      const show = typeof quantity === 'number' && quantity > 0 && quantity <= threshold;
      notice.hidden = !show;
      if (show) $('[data-low-stock-text]', notice).textContent = `Only ${quantity} left in stock`;
    }

    // Desktop: show the bar once the real button has scrolled away. Mobile (when enabled): also show it
    // before the shopper reaches the button, so "Add to cart" is always one tap away.
    initSticky() {
      if (!this.sticky || !this.atc || !('IntersectionObserver' in window)) return;
      const button = $('[data-sticky-button]', this.sticky);
      const earlyOnMobile = this.sticky.hasAttribute('data-early-mobile') && window.matchMedia('(max-width: 749px)');
      new IntersectionObserver(([entry]) => {
        const scrolledPast = entry.boundingClientRect.top < 0;
        const show = !entry.isIntersecting && (scrolledPast || Boolean(earlyOnMobile && earlyOnMobile.matches));
        this.sticky.classList.toggle('is-visible', show);
        this.sticky.setAttribute('aria-hidden', String(!show));
        if (button) button.tabIndex = show ? 0 : -1;
      }).observe(this.atc);
    }
  }

  /* Delivery estimate ---------------------------------------------------- */

  function initDelivery(root = document) {
    const locale = document.documentElement.lang || undefined;
    const format = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
    const inDays = (days) => {
      const date = new Date();
      date.setDate(date.getDate() + days);
      return format.format(date);
    };
    $$('[data-delivery]', root).forEach((el) => {
      const range = $('[data-delivery-range]', el);
      if (range) range.textContent = `${inDays(Number(el.dataset.min))} – ${inDays(Number(el.dataset.max))}`;
    });
  }

  /* Boot ----------------------------------------------------------------- */

  function init(root = document) {
    initAnnouncements(root);
    initDelivery(root);
    $$('[data-product]', root).forEach((el) => {
      if (!el.productInstance) el.productInstance = new Product(el);
    });
  }

  init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  window.Arcwell = { Cart, formatMoney };
})();
